import { formatCredits } from "./format";

import type { Amount } from "@/shared/types/billing";

/* What is left of the plan's monthly credits. A top-up can lift the balance past
   the plan's grant, so the bar stops at full; under a fifth left it turns warn. */
export default function CreditsMeter({ balance, of, className = "" }: {
  balance: Amount;
  /** The plan's credits; without them only the balance shows. */
  of: Amount | null;
  className?: string;
}) {
  const left = Math.max(0, Number(balance));
  const total = Number(of ?? 0);
  const pct = total > 0 ? Math.min(100, Math.round((left / total) * 100)) : 100;
  return (
    <div className={className}>
      <div className="flex items-baseline justify-between gap-2 text-[11.5px] text-[var(--text-tertiary)]">
        <span>Credits left</span>
        <span className="font-mono tabular-nums text-[var(--text-secondary)]">
          {formatCredits(balance)}
          {total > 0 && <span className="text-[var(--text-quaternary)]"> / {formatCredits(total)}</span>}
        </span>
      </div>
      <span
        role="meter"
        aria-label="Credits left"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        className="mt-1.5 block h-[4px] w-full rounded-full bg-[var(--surface-2)] overflow-hidden"
      >
        <span
          className={`block h-full rounded-full transition-[width] duration-500 ${pct < 20 ? "bg-[var(--warn)]" : "bg-[var(--brand)]"}`}
          style={{ width: `${pct}%` }}
        />
      </span>
    </div>
  );
}
